import { render } from "./Sala3It.vue?vue&type=template&id=99d69d76"
import script from "./Sala3It.vue?vue&type=script&lang=js"
export * from "./Sala3It.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__